<template>
	<div class="page yarn-count-converter">
		<section id="navigation">
			<div class="container">
				<div class="content flex">
					<span @click="$router.go(-1);" class="go-back"><svg class="navigation-icon link-icon small" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 20"><path d="M.8 10L10.36.44 13.2 3.3 6.5 10l6.72 6.7-2.85 2.85L.8 10z"/></svg></span>
					<svg class="navigation-icon left" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path d="M50 100a50 50 0 1 1 50-50 50.06 50.06 0 0 1-50 50zm0-96a46 46 0 1 0 46 46A46.05 46.05 0 0 0 50 4zm42 48H56v-4h31.95a38 38 0 0 0-75.9 0H44v4H8v-2a42 42 0 0 1 84 0z"/><path d="M50 58a8 8 0 1 1 8-8 8 8 0 0 1-8 8zm0-12a4 4 0 1 0 4 4 4 4 0 0 0-4-4zm21 38H29a2 2 0 0 1-2-2V64a2 2 0 0 1 2-2h42a2 2 0 0 1 2 2v18a2 2 0 0 1-2 2zm-40-4h38V66H31zm19-62a2 2 0 0 1-2-2v-6a2 2 0 0 1 4 0v6a2 2 0 0 1-2 2zM26 28a2 2 0 0 1-1.41-.59l-4.3-4.28a2 2 0 0 1 2.83-2.83l4.24 4.24A2 2 0 0 1 26 28z"/><path d="M74 28a2 2 0 0 1-1.41-3.41l4.24-4.24a2 2 0 0 1 2.83 2.83l-4.24 4.24A2 2 0 0 1 74 28zM56 50a2 2 0 0 1-1.93-1.47L50 33.6l-4.07 14.93a2 2 0 0 1-3.86-1.05l6-22a2 2 0 0 1 3.86 0l6 22A2 2 0 0 1 56 50z"/></svg>
					<span class="navigation-title">{{machine.name}}</span>
					<div class="navigation-right">
						<DotMenu alignment="right">
							<DotMenuItem @clicked="save">{{$t('save')}}</DotMenuItem>
							<DotMenuSeparator/>
							<DotMenuItem @clicked="remove" class="delete">{{$t('delete')}}</DotMenuItem>
						</DotMenu>
					</div>
				</div>
			</div>
		</section>
		<transition name="slide-up" mode="out-in" appear>
			<section class="main">
				<form @submit.prevent="save" ref="form">
					<div class="field">
						<div class="container">
							<div class="content">
								<div class="field-inner">
									<label for="customer">{{$t('customer')}}*</label>
									<div class="element">
										<model-list-select
											id="customer"
											:list="customers"
											v-model="newMachine.customerId"
											option-value="id"
											:custom-text="customerText"
											:placeholder="$t('select-customer')">
										</model-list-select>
									</div>
									<label for="machine-type">{{$t('machine-type')}}*</label>
									<div class="element">
										<model-list-select
											id="machine-type"
											:list="machineTypes"
											v-model="newMachine.machineTypeId"
											option-value="id"
											:custom-text="machineTypeText"
											:placeholder="$t('select-machine-type')">
										</model-list-select>
									</div>
									<label for="spindles-number">{{$t('spindles-number')}}*</label>
									<div class="element">
										<input type="number" required placeholder=" " min="0" step="1" v-model="newMachine.spindlesNumber" id="spindles-number">
										<div class="requirements">{{$t('machine-spindles-number-requirements')}}</div>
									</div>
									<label for="serial-number">{{$t('serial-number')}}*</label>
									<div class="element">
										<input type="text" required placeholder=" " v-model="newMachine.serialNumber" id="serial-number">
									</div>
									<label for="code">{{$t('code')}}</label>
									<div class="element">
										<div class="flex">
											<input type="text" placeholder="" id="code" v-model="newMachine.code" readonly>
										</div>
									</div>
									<label for="remote-enabled">{{$t('remote-enabled')}}*</label>
									<div class="element">
										<select v-model="newMachine.remoteEnabled">
											<option :value="0">{{$t('disabled')}}</option>
											<option :value="1">{{$t('enabled')}}</option>
										</select>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- <hr>
					<div class="container">
						<div class="content">
							<button class="">{{$t('save')}}</button>
							<br>
							<br>
							<button @click.prevent="remove">{{$t('delete')}}</button>
						</div>
					</div>
					<br>
					<hr> -->
					<!-- <div class="field">
						<div class="container">
							<div class="content">
								<div class="field-inner">
									<div class="element">
										<div class="flex" data-cols="3">
											<div class="flex-inner">
												<label for="document">{{$t('document')}}*</label>
												<model-list-select
													id="document"
													:list="documents"
													v-model="newMachine.documentId"
													option-value="id"
													:custom-text="documentText"
													:placeholder="$t('select-document')">
												</model-list-select>
											</div>
											<div class="flex-inner">
												<label for="name">{{$t('name')}}</label>
												<input type="text" placeholder="" id="name" >
											</div>
											<div class="flex-inner">
												<label for="description">{{$t('description')}}</label>
												<input type="text" placeholder="" id="description" >
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div> -->
					<hr>
					<div class="container">
						<div class="content">
							<button class="">{{$t('save')}}</button>
						</div>
					</div>
					<br>
					<hr>
					<div class="field">
						<div class="container">
							<div class="content">
								<div class="field-inner">
									<label for="document">{{$t('machine-documents')}}</label>
									<div class="element">
										<div class="flex">
											<table class="grid">
												<thead>
													<tr>
														<th class="icon"></th>
														<th>{{$t('document')}}</th>
														<th>{{$t('name')}}</th>
														<th>{{$t('description')}}</th>
													</tr>
												</thead>
												<tbody>
													<tr
													v-for="(item, index) in machineDocuments"
													:key="'item-'+index"
													>
														<td class="icon">
															<DotMenu>
																<DotMenuItem @clicked="saveDocument(item)">{{$t('save')}}</DotMenuItem>
																<DotMenuItem @clicked="viewDocument(item)">{{$t('view')}}</DotMenuItem>
																<DotMenuSeparator/>
																<DotMenuItem @clicked="removeDocument(item)" class="delete">{{$t('delete')}}</DotMenuItem>
															</DotMenu>
														</td>
														<td class="input">
															<!-- <model-list-select
																:list="documents"
																v-model="item.documentId"
																option-value="id"
																:custom-text="documentText"
																:placeholder="$t('select-document')">
															</model-list-select> -->
															<input type="text" placeholder="" v-model="item.documentName" readonly>
														</td>
														<td class="input">
															<input type="text" placeholder="" v-model="item.name">
														</td>
														<td class="input">
															<input type="text" placeholder="" v-model="item.description">
														</td>
													</tr>
												</tbody>
											</table>
										</div>
									</div>
									<label for="document">{{$t('add-document')}}</label>
									<div class="element">
										<div class="flex">
											<table class="grid add">
												<thead>
													<tr>
														<th class="icon"></th>
														<th>{{$t('document')}}</th>
														<th>{{$t('name')}}</th>
														<th>{{$t('description')}}</th>
													</tr>
												</thead>
												<tbody>
													<tr>
														<td class="icon"></td>
														<td class="input">
															<model-list-select
																:list="remainingDocuments"
																v-model="newMachineDocument.documentId"
																option-value="id"
																:custom-text="documentText"
																:placeholder="$t('select-document')">
															</model-list-select>
														</td>
														<td class="input">
															<input type="text" placeholder="" v-model="newMachineDocument.name">
														</td>
														<td class="input">
															<input type="text" placeholder="" v-model="newMachineDocument.description">
														</td>
													</tr>
												</tbody>
											</table>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="container">
						<div class="content">
							<span class="button " @click.prevent="addDocument">{{$t('add')}}</span>
						</div>
					</div>

					<!-- <SortableTable :columns="columns" :items="machineDocuments" :sort="sort" :showSearchBar="true" :showHeader="true"/> -->
				</form>
			</section>
		</transition>
	</div>
</template>

<script>
// @ is an alias to /src
import {ModelListSelect} from 'vue-search-select'
import DotMenu from '@/components/DotMenu/DotMenu.vue'
import DotMenuItem from '@/components/DotMenu/DotMenuItem.vue'
import DotMenuSeparator from '@/components/DotMenu/DotMenuSeparator.vue'
import SortableTable from '@/components/SortableTable.vue'

export default {
	data() {
		return {
			// columns: [
			// 	{name: this.$t('document'), id: "documentId", canMove: true, sortable: true, type: 'numeric'},//, hide: true },
			// 	{name: this.$t('name'), id: "name", canMove: true, sortable: true},
			// 	{name: this.$t('description'), id: "description", canMove: true, sortable: true},
			// ],
			// sort: {on: "name", direction: "asc", type: "text"},


			newMachine: {
				id: '',
				customerId: '',
				machineTypeId: '',
				spindlesNumber: '',
				serialNumber: '',
				code: '',
				remoteEnabled: 1,
			},
			machine: {},
			customers: [],
			machineTypes: [],
			documents: [],
			machineDocuments: [],
			newMachineDocument: {
				documentId: '',
				name: '',
				description: '',
			},
			saveError: false,
			addDocumentError: false,
			saveDocumentError: false,
		}
	},
	components: {
		ModelListSelect,
		DotMenu,
		DotMenuItem,
		DotMenuSeparator,
		SortableTable,
	},
	computed: {
		remainingDocuments() {
			let self = this;
			return self.documents.filter(o => !self.machineDocuments.map(e => e.documentId).includes(o.id));
		},
	},
	created() {
		let self = this;

		axios.get(`/customers`)
		.then((response) => {
			self.customers = response.data.response.customers;
		});

		axios.get(`/machine-types`)
		.then((response) => {
			self.machineTypes = response.data.response.machineTypes;
		});

		axios.get(`/documents`)
		.then((response) => {
			self.documents = response.data.response.documents;
		});

		axios.get(`/machines/${self.$route.params.id}/documents`)
		.then((response) => {
			self.machineDocuments = response.data.response.machineDocuments;
		});

		axios.get(`/machines/${self.$route.params.id}`)
		.then((response) => {
			self.machine = {...response.data.response.machine};
			self.newMachine = {...response.data.response.machine};
		})
		.catch((err) => {
			self.$router.go(-1);
		});
	},
	methods: {
		customerText(item) {
			return `${item.name}${item.vat_number != null? ` (${item.vat_number})`: ``}`
		},
		machineTypeText(item) {
			return `${item.name}`
		},
		documentText(item) {
			return `${item.name}`
		},
		save() {
			if (!this.$refs.form.checkValidity()) {
				// Try focus on the error 
				this.$refs.form.reportValidity();
				return;
			}

			this.saveError = false;

			if (JSON.stringify(this.machine) === JSON.stringify(this.newMachine)) {
				this.$snack.success(this.$t('nothing-to-save'));
				return;
			}

			if (!this.newMachine.customerId ||
				!this.newMachine.machineTypeId ||
				!this.newMachine.spindlesNumber ||
				!this.newMachine.serialNumber) {
				this.saveError = true;
				this.$snack.danger(this.$t('compile-all-required-fields'));
			}

			if (!this.saveError) {
				let params = new URLSearchParams();

				params.append('customerId', this.newMachine.customerId);
				params.append('machineTypeId', this.newMachine.machineTypeId);
				params.append('spindlesNumber', this.newMachine.spindlesNumber);
				params.append('serialNumber', this.newMachine.serialNumber);
				params.append('remoteEnabled', this.newMachine.remoteEnabled);

				let self = this;
				axios.put(`/machines/${self.$route.params.id}`, params)
				.then((response) => {
					self.$snack.success(self.$t('saved-successfully'));
					self.machine = {...self.newMachine};
				})
				.catch((err) => {
					let resp = err.response;
					if (resp.data.response && resp.data.response.duplicate) {
						switch (resp.data.response.duplicate) {
							case 'serial_number':
								self.$snack.danger(self.$t('duplicate-serial-number-error'));
								break;
						}
					} else {
						self.$snack.danger(self.$t('save-error'));
					}
					self.saveError = true;
					if (navigator.vibrate){
						navigator.vibrate([500]);
					}
				});
			}
		},
		remove() {
			let self = this;
			let onConfirm = (buttonIndex) => {
				if (buttonIndex == 1) {
					axios.delete(`/machines/${self.$route.params.id}`)
					.then((response) => {
						self.$snack.success(self.$tc('machine-deleted-successfully', 1, {count: 1}));
						self.$router.go(-1);
					})
					.catch((err) => {
						let resp = err.response;
						self.$snack.danger(self.$t('delete-error'));

						if (navigator.vibrate){
							navigator.vibrate([500]);
						}
					});
				}
			}
			let message = self.$tc('delete-machine-confirm', 1, {count: 1});
			if (navigator.notification) {
				navigator.notification.confirm(
					message,	// message
					onConfirm,						// callback to invoke with index of button pressed
					this.$t('delete-machine'),			// title
					[this.$t('confirm'),
					this.$t('cancel')]	// buttonLabels
				);
			} else {
				if (confirm(message)) onConfirm(1);
			}
		},
		addDocument() {
			this.addDocumentError = false;

			if (!this.newMachineDocument.documentId ||
				!this.newMachineDocument.name) {
				this.addDocumentError = true;
				this.$snack.danger(this.$t('compile-all-required-fields'));
			}

			if (!this.addDocumentError) {
				let params = new URLSearchParams();

				params.append('machineId', this.machine.id);
				params.append('documentId', this.newMachineDocument.documentId);
				params.append('name', this.newMachineDocument.name || '');
				params.append('description', this.newMachineDocument.description || '');

				let self = this;
				axios.post(`/machines/${self.$route.params.id}/documents/create`, params)
				.then((response) => {
					self.$snack.success(self.$t('saved-successfully'));

					return axios.get(`/machines/${self.$route.params.id}/documents`);
				})
				.then((response) => {
					self.machineDocuments = response.data.response.machineDocuments;
					self.newMachineDocument = {};
				})
				.catch((err) => {
					let resp = err.response;
					if (resp.data.response && resp.data.response.duplicate) {
						switch (resp.data.response.duplicate) {
							case 'machine_document':
								self.$snack.danger(self.$t('duplicate-document-error'));
								break;
						}
					} else {
						self.$snack.danger(self.$t('save-error'));
					}
					self.addDocumentError = true;
					if (navigator.vibrate){
						navigator.vibrate([500]);
					}
				});
			}
		},
		saveDocument(item) {
			this.saveDocumentError = false;

			if (!item.documentId ||
				!item.name) {
				this.saveDocumentError = true;
				this.$snack.danger(this.$t('compile-all-required-fields'));
			}

			if (!this.saveDocumentError) {
				let params = new URLSearchParams();

				params.append('name', item.name || '');
				params.append('description', item.description || '');

				let self = this;
				axios.put(`/machines/${self.$route.params.id}/documents/${item.documentId}`, params)
				.then((response) => {
					self.$snack.success(self.$t('saved-successfully'));

					return axios.get(`/machines/${self.$route.params.id}/documents`);
				})
				.then((response) => {
					self.machineDocuments = response.data.response.machineDocuments;
				})
				.catch((err) => {
					let resp = err.response;
					if (resp.data.response && resp.data.response.duplicate) {
						switch (resp.data.response.duplicate) {
							case 'machine_document':
								self.$snack.danger(self.$t('duplicate-document-error'));
								break;
							case 'name':
								self.$snack.danger(self.$t('duplicate-name-error'));
								break;
						}
					} else {
						self.$snack.danger(self.$t('save-error'));
					}
					self.saveDocumentError = true;
					if (navigator.vibrate){
						navigator.vibrate([500]);
					}
				});
			}
		},
		viewDocument(item) {
		},
		removeDocument(item) {
			let self = this;
			let onConfirm = (buttonIndex) => {
				if (buttonIndex == 1) {
					axios.delete(`/machines/${self.$route.params.id}/documents/${item.documentId}`)
					.then((response) => {
						self.$snack.success(self.$tc('document-deleted-successfully', 1, {count: 1}));

						return axios.get(`/machines/${self.$route.params.id}/documents`);
					})
					.then((response) => {
						self.machineDocuments = response.data.response.machineDocuments;
						self.newMachineDocument = {};
					})
					.catch((err) => {
						let resp = err.response;
						self.$snack.danger(self.$t('delete-error'));

						if (navigator.vibrate){
							navigator.vibrate([500]);
						}
					});
				}
			}
			let message = self.$tc('delete-document-confirm', 1, {count: 1});
			if (navigator.notification) {
				navigator.notification.confirm(
					message,	// message
					onConfirm,						// callback to invoke with index of button pressed
					this.$t('delete-document'),			// title
					[this.$t('confirm'),
					this.$t('cancel')]	// buttonLabels
				);
			} else {
				if (confirm(message)) onConfirm(1);
			}
		},
	},
}
</script>

<style scoped>
	.add td {
		background: #fff;
	}
</style>